import { getFirebaseToken } from '../firebase'

interface GeneratePayload {
  pageNumber: number
  photoBookId: string
  imageBase64?: string
  imageUrl?: string
  toapis?: string
}

class PhotoService {
  constructor(private baseUrl: string, private projectName: string) {}
  private async request<T>(path: string, payload: unknown, signal?: AbortSignal): Promise<T> {
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: 'POST', signal,
      headers: { Authorization: `Bearer ${await getFirebaseToken()}`, 'Content-Type': 'application/json', XProjectName: this.projectName },
      body: JSON.stringify({ ...(payload as object), projectName: this.projectName }),
    })
    if (!response.ok) throw new Error(`Photo request failed (${response.status})`)
    return response.json() as Promise<T>
  }
  generateArtBookPage(payload: GeneratePayload, signal?: AbortSignal) {
    return this.request<{ generationUuid: string; generatedImagePath: string; generatedImageUrl: string; themeId: string; themeVersion: string; pageId: string; pageTitle: string; revision: number }>(`/api/ai/art-book/pages/${payload.pageNumber}`, payload, signal)
  }
  generateCharacterAnchor(payload: { photoBookId: string }, signal?: AbortSignal) {
    return this.request<{ generatedImagePath: string; generatedImageUrl: string; revision: number }>('/api/ai/art-book/character-anchor', payload, signal)
  }
  uploadImages(payload: { images: string[] }, signal?: AbortSignal) {
    return this.request<{ results: Array<{ imageUuid: string; imagePath: string; imageUrl: string; toapis?: string }> }>('/api/ai/images/upload', payload, signal)
  }
}

export const photoService = new PhotoService(import.meta.env.VITE_API_URL, 'kids-art-book')
